<div class="record-attachments">
  <div class="section-header">
    <h4>
      Attachments
      @if (
        totalItems > 0 ||
        outreachAttachments.length > 0 ||
        businessFiles.length > 0
      ) {
        <span class="count-text"
          >({{
            totalItems + outreachAttachments.length + businessFiles.length
          }})</span
        >
      }
    </h4>
    <div class="header-actions">
      @if (recordUniqueId && hasUploadRecordsPermission) {
        <button
          class="add-file-btn"
          (click)="openAddFileModal()"
          [disabled]="isLoading"
          title="Add attachment"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          Add
        </button>
      }
    </div>
  </div>

  <div class="attachments-list">
    @if (isLoading) {
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
    } @else if (
      files.length === 0 &&
      outreachAttachments.length === 0 &&
      businessFiles.length === 0
    ) {
      <div class="empty-state">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          ></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </svg>
        <p>No files attached yet</p>
      </div>
    } @else {
      @for (file of files; track file.id) {
        <div
          class="attachment-item fade-in"
          (click)="downloadFile(file)"
          (keyup.enter)="downloadFile(file)"
          tabindex="0"
        >
          <div class="file-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z M13 3.5L18.5 9H13V3.5z M8 13h8 M8 17h8 M8 9h2"
              />
            </svg>
          </div>
          <div class="file-info">
            <div class="file-name" [title]="getFileName(file)">
              {{ getFileName(file) }}
            </div>
            <div class="file-meta">
              <span
                >{{ file.file.uploaded_user.first_name }}
                {{ file.file.uploaded_user.last_name }}</span
              >
              <span>•</span>
              <span>{{ file.file.uploaded_datetime | date: "medium" }}</span>
            </div>
          </div>
          <div class="file-actions">
            <button
              class="action-btn"
              (click)="downloadFile(file, true); $event.stopPropagation()"
              title="Download"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </button>
            @if (canManage(file)) {
              <button
                class="action-btn"
                (click)="openShareModal(file); $event.stopPropagation()"
                title="Manage Sharing"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
              </button>
              <button
                class="action-btn delete-btn"
                (click)="confirmDelete(file); $event.stopPropagation()"
                title="Unlink"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M15 7h3a5 5 0 0 1 0 10h-3m-6 0H6a5 5 0 0 1 0-10h3"
                  ></path>
                  <line x1="2" y1="2" x2="22" y2="22"></line>
                </svg>
              </button>
            }
          </div>
        </div>
      }

      @for (attachment of businessFiles; track attachment.file_id) {
        <div
          class="attachment-item outreach-item fade-in"
          (click)="downloadFile(attachment)"
          (keyup.enter)="downloadFile(attachment)"
          tabindex="0"
        >
          <div class="file-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z M13 3.5L18.5 9H13V3.5z M8 13h8 M8 17h8 M8 9h2"
              />
            </svg>
          </div>
          <div class="file-info">
            <div class="file-name" [title]="attachment.file_name">
              {{ attachment.file_name }}
            </div>
          </div>
          <div class="file-actions">
            <!-- <span class="source-tag">Business Doc</span> -->
            <button
              class="action-btn"
              (click)="downloadFile(attachment, true); $event.stopPropagation()"
              title="Download"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </button>
          </div>
        </div>
      }

      @for (attachment of outreachAttachments; track attachment.file_id) {
        <div
          class="attachment-item outreach-item fade-in"
          (click)="downloadFile(attachment)"
          (keyup.enter)="downloadFile(attachment)"
          tabindex="0"
        >
          <div class="file-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z M13 3.5L18.5 9H13V3.5z M8 13h8 M8 17h8 M8 9h2"
              />
            </svg>
          </div>
          <div class="file-info">
            <div class="file-name" [title]="attachment.file_name">
              {{ attachment.file_name }}
            </div>
          </div>
          <div class="file-actions">
            <span class="source-tag">Deeproots</span>
            <button
              class="action-btn"
              (click)="downloadFile(attachment, true); $event.stopPropagation()"
              title="Download"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </button>
          </div>
        </div>
      }
    }
  </div>

  @if (totalItems > pageSize) {
    <div class="pagination-footer">
      <app-pagination
        [currentPage]="currentPage"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        (pageChanged)="onPageChange($event)"
      ></app-pagination>
    </div>
  }
</div>

<!-- Modal Dialogs (Add File Options, Upload/Library Modal, Share Modal, Delete Confirm) -->
<!-- These use the app-popup component -->

@if (showAddFileOptionModal) {
  <app-popup
    heading="Add Attachment"
    (cancelClicked)="showAddFileOptionModal = false"
    [showFooterButtons]="false"
    [showCloseIcon]="true"
  >
    <div class="modal-body">
      <div class="upload-options">
        <div
          class="upload-option-card"
          (click)="openUploadModal()"
          (keyup.enter)="openUploadModal()"
          tabindex="0"
        >
          <div class="icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
          </div>
          <h4>Upload New File</h4>
          <p>Choose a file from your computer</p>
        </div>
        <div
          class="upload-option-card"
          (click)="openLibraryModal()"
          (keyup.enter)="openLibraryModal()"
          tabindex="0"
        >
          <div class="icon-wrapper">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
              <path
                d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
              ></path>
            </svg>
          </div>
          <h4>Choose from Library</h4>
          <p>Select from previously uploaded files</p>
        </div>
      </div>
    </div>
  </app-popup>
}

<!-- Upload/Library Modal -->
@if (showAttachModal) {
  <app-popup
    [heading]="isUploading ? 'Upload and Attach File' : 'Select from Library'"
    [confirmText]="attachButtonText"
    cancelText="Cancel"
    [isConfirmDisabled]="isAttachButtonDisabled"
    (confirmClicked)="attachSelectedFile()"
    (cancelClicked)="closeAttachModal()"
  >
    <div class="modal-body">
      @if (isUploading) {
        <div class="form-group upload-section">
          <label for="fileUploadInput" class="form-label">Choose File</label>
          <div
            class="file-drop-zone"
            (click)="fileUploadInput.click()"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            tabindex="0"
            (keyup.enter)="fileUploadInput.click()"
            [class.drag-over]="isDragging"
          >
            <input
              #fileUploadInput
              type="file"
              id="fileUploadInput"
              style="display: none"
              accept=".doc,.docx,.xlsx,.xls,.xlsm,.odt,.pdf,.txt,.zip,.csv"
              (change)="onFileSelected($event)"
            />
            @if (!selectedUploadFile) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
              <p class="drop-zone-text">Click to upload or drag and drop</p>
              <p class="drop-zone-hint">
                Supported: .doc, .xlsx, .xls, .odt, .pdf, .txt, .docx, .zip,
                .csv, .xlsm (Max file size: 1GB)
              </p>
            } @else {
              <div class="selected-file-display">
                <div class="file-details">
                  <span class="file-name-bold">{{
                    selectedUploadFile.name
                  }}</span>
                  <span class="file-size-hint"
                    >({{
                      (selectedUploadFile.size / 1024 / 1024).toFixed(2)
                    }}
                    MB)</span
                  >
                </div>
                <button
                  class="remove-file-btn"
                  (click)="removeSelectedFile(); $event.stopPropagation()"
                  title="Remove file"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            }
          </div>
          @if (validationErrors.length > 0) {
            <div class="error-messages">
              @for (error of validationErrors; track error) {
                <p class="error-text text-danger">{{ error }}</p>
              }
            </div>
          }

          <div class="consent-container">
            <label
              class="consent-checkbox"
              [class.disabled]="!selectedUploadFile"
            >
              <input
                type="checkbox"
                [(ngModel)]="hasConsentChecked"
                [disabled]="!selectedUploadFile"
              />
              <span class="consent-text">
                By uploading this document, you verify that you have the proper
                rights and permissions to upload, share, or view this document.
                The information in this file is up to date, accurate, and does
                not contain any illegal or malicious contents.
              </span>
            </label>
          </div>
        </div>
      } @else {
        <!-- Library View -->
        <div class="form-group library-section">
          <div class="form-label">Choose files from your library</div>
          <p class="library-helper-text">
            Need to add files to your library? Upload them
            <a href="/files" class="library-helper-link">here</a>.
          </p>

          <div class="search-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="search-icon"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              class="search-input"
              placeholder="Search ..."
              [(ngModel)]="librarySearchQuery"
            />
          </div>

          <div class="file-list-picker">
            @if (isLoadingLibraryFiles) {
              <div class="spinner-container">
                <div class="spinner"></div>
              </div>
            } @else if (libraryFiles.length === 0) {
              <div class="empty-state-small">
                @if (totalUploadedFilesCount === 0) {
                  No files available in your library.
                } @else {
                  All your library files are already attached to this record.
                }
              </div>
            } @else if (filteredLibraryFiles.length === 0) {
              <div class="empty-state-small">No files match your search.</div>
            } @else {
              @for (file of filteredLibraryFiles; track file.id) {
                <div
                  class="picker-item"
                  [class.selected]="selectedFileIds.has(file.id)"
                  (click)="toggleFileSelection(file.id)"
                  (keyup.enter)="toggleFileSelection(file.id)"
                  tabindex="0"
                >
                  <input
                    type="checkbox"
                    class="picker-checkbox"
                    [checked]="selectedFileIds.has(file.id)"
                  />
                  <div class="picker-item-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-7-7z"
                      ></path>
                      <polyline points="13 2 13 9 20 9"></polyline>
                    </svg>
                  </div>
                  <div class="picker-item-name">{{ file.blob_name }}</div>
                  <div class="picker-item-date">
                    {{ file.uploaded_datetime | date: "medium" }}
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }

      <!-- Visibility Selector (Available for both Upload and Library) -->
      <!-- Hide when in library mode and all files are already attached -->
      @if (isUploading || libraryFiles.length > 0) {
        <div class="form-group share-section">
          <div class="form-label">
            Share with
            <span class="optional-hint"
              >(Optional, you can change this later)</span
            >
          </div>
          <div class="visibility-selector">
            <!-- Row 1: Only Me and My Organization side by side -->
            <div class="share-options-row">
              <label
                class="radio-option compact"
                [class.selected]="visibilityMode === 'me'"
              >
                <input
                  type="radio"
                  name="visibility"
                  value="me"
                  [(ngModel)]="visibilityMode"
                />
                <div class="option-content">
                  <span class="option-title">Only Me</span>
                  <span class="option-desc">Private to your account</span>
                </div>
              </label>

              <label
                class="radio-option compact"
                [class.selected]="visibilityMode === 'org'"
              >
                <input
                  type="radio"
                  name="visibility"
                  value="org"
                  [(ngModel)]="visibilityMode"
                />
                <div class="option-content">
                  <span class="option-title">My Organization</span>
                  <span class="option-desc"
                    >Share with everyone in your team</span
                  >
                </div>
              </label>
            </div>

            <!-- Row 2: Specific People (full width, expandable) -->
            <div class="share-options-full">
              <label
                class="radio-option expandable"
                [class.selected]="visibilityMode === 'selected'"
                [class.expanded]="visibilityMode === 'selected'"
              >
                <input
                  type="radio"
                  name="visibility"
                  value="selected"
                  [(ngModel)]="visibilityMode"
                />
                <div class="option-content">
                  <div class="option-header">
                    <div>
                      <span class="option-title">Selected Organizations</span>
                      <span class="option-desc"
                        >Choose organizations from this record's assignees</span
                      >
                    </div>
                    @if (
                      selectedConnectionIds.size > 0 &&
                      visibilityMode === "selected"
                    ) {
                      <span class="selected-count"
                        >{{ selectedConnectionIds.size }} selected</span
                      >
                    }
                  </div>
                </div>
                <div
                  class="expand-icon"
                  [class.rotated]="visibilityMode === 'selected'"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </div>
              </label>

              <!-- Expanded content -->
              @if (visibilityMode === "selected") {
                <div class="org-selector-wrapper">
                  <div class="org-selector">
                    @if (sortedConnections.length === 0) {
                      <p class="empty-message">
                        No assignees available to share.
                      </p>
                    } @else {
                      <div class="select-all-row">
                        <label class="select-all-label">
                          <input
                            type="checkbox"
                            [checked]="isAllSelected"
                            (change)="toggleAllConnections()"
                          />
                          Select All
                        </label>
                      </div>
                      @for (conn of sortedConnections; track conn.id) {
                        <div class="checkbox-item">
                          <label>
                            <input
                              type="checkbox"
                              [checked]="selectedConnectionIds.has(conn.id)"
                              (change)="toggleConnection(conn.id)"
                            />
                            <span class="org-name">{{
                              conn.display_name || conn.connection_name
                            }}</span>
                            @if (conn.id === currentUserConnectionId) {
                              <span class="org-badge your-org">You</span>
                            }
                          </label>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </app-popup>
}

<!-- Share Modal -->
@if (showShareModal) {
  <app-popup
    heading="Manage File Sharing"
    confirmText="Save"
    cancelText="Cancel"
    [isConfirmDisabled]="isSavingSharing || isLoadingSharing"
    (confirmClicked)="saveSharing()"
    (cancelClicked)="closeShareModal()"
  >
    <div class="modal-body popup-body-spacing">
      @if (isLoadingSharing) {
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
      } @else {
        <p class="popup-subtitle">
          Select Organizations to share the file with
        </p>
        <div class="org-checklist-container">
          @if (sortedConnections.length === 0) {
            <p class="empty-message">No assignees available to share.</p>
          } @else {
            @for (conn of sortedConnections; track conn.id) {
              <div
                class="checkbox-item-row"
                [class.selected]="selectedConnectionIds.has(conn.id)"
                (click)="toggleConnection(conn.id)"
                (keyup.enter)="toggleConnection(conn.id)"
                tabindex="0"
              >
                <div class="checkbox-wrapper">
                  <input
                    type="checkbox"
                    (click)="$event.stopPropagation()"
                    [checked]="selectedConnectionIds.has(conn.id)"
                    (change)="
                      toggleConnection(conn.id); $event.stopPropagation()
                    "
                  />
                  <span class="checkmark"></span>
                </div>
                <span class="org-name">{{
                  conn.display_name || conn.connection_name
                }}</span>
                @if (conn.id === currentUserConnectionId) {
                  <span class="org-badge your-org">You</span>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  </app-popup>
}

<!-- Delete Modal -->
@if (showDeleteModal) {
  <app-popup
    heading="Remove Attachment"
    confirmText="Remove"
    cancelText="Cancel"
    [isConfirmDisabled]="isDeleting"
    (confirmClicked)="proceedWithDelete()"
    (cancelClicked)="closeDeleteModal()"
  >
    <div class="modal-body popup-body-spacing">
      <p class="popup-message">
        Are you sure you want to remove this file attachment?
      </p>
      <div class="file-name-callout">
        {{ fileToDelete ? getFileName(fileToDelete) : "" }}
      </div>
    </div>
  </app-popup>
}

<app-file-viewer
  [showViewer]="showFileViewer"
  [fileUrl]="viewerFileUrl"
  [fileName]="viewerFileName"
  (closeViewer)="onCloseViewer()"
  (downloadFile)="onViewerDownload()"
></app-file-viewer>
